const adminPanelDictIT = {
  adminPanelSectionMain: "Principale",
  adminPanelSectionSales: "Vendite",
  adminPanelSectionCatalog: "Catalogo",
  adminPanelSectionFinance: "Finanza",
  adminPanelSectionStorefront: "Negozio e marketing",
  adminPanelUserLists: "Elenchi utenti",
  adminPanelBanners: "Banner",
  adminPanelSearchMenu: "Cerca nel menu",
  adminPanelNoMenuResults: "Nessun elemento trovato",
  adminPanelOpenMenu: "Apri menu",
  adminPanelBeta: "Beta",
  adminPanelUseClassic: "Torna all'admin classico",
  adminPanelTryNew: "Prova il nuovo admin",
  adminPanelChooseTitle: "Quale versione dell'admin vuoi usare?",
  adminPanelChooseSubtitle:
    "Stiamo migrando il pannello amministrativo a un nuovo design. Entrambe le versioni hanno le stesse funzionalità.",
  adminPanelNewVersion: "Nuovo admin",
  adminPanelNewVersionDescription: "Aspetto moderno, menu organizzato per area e ricerca rapida.",
  adminPanelClassicVersion: "Admin classico",
  adminPanelClassicVersionDescription: "Il pannello di sempre, senza modifiche.",
  adminPanelChooseHint: "La tua scelta vale fino al logout. Puoi cambiare versione in qualsiasi momento con il pulsante in alto.",

  // Home
  adminHomeNeedsAttention: "Richiede attenzione",
  adminHomeNeedsAttentionHint: "Elementi in sospeso attuali, indipendenti dal periodo selezionato",
  adminHomeAllClear: "Tutto in ordine",
  adminHomePendingBankTransfers: "Bonifici da confermare",
  adminHomePendingOrders: "Ordini con problemi",
  adminHomePendingWithdraws: "Prelievi in elaborazione",
  adminHomePendingBangood: "Ordini Bangood non elaborati",
  adminHomePendingPhysicalStores: "Negozi fisici da verificare",
  adminHomeIndicators: "Indicatori",
  adminHomeCustomPeriod: "Periodo personalizzato",
  adminHomeGroupRevenue: "Ricavi",
  adminHomeGroupOperation: "Operatività",
  adminHomeGroupWithdraws: "Prelievi",
  adminHomeTotalUsers: "utenti in totale",
  adminHomeTotalProducts: "prodotti in totale",

  // Listas de usuários
  adminUsersStatusAll: "Tutti",
  adminUsersStatusActive: "Attivi",
  adminUsersStatusBlocked: "Bloccati",
  adminUsersStatusCancelled: "Cancellati",
  adminUsersStatusFilter: "Filtra per stato",
  adminUsersSearchPlaceholder: "Cerca per nome, username, e-mail, telefono o referente",
  adminUsersCreatedBetween: "Data di registrazione",
  adminUsersClearFilters: "Cancella filtri",
  adminUsersResults: "risultato/i",
  adminUsersUser: "Utente",
  adminUsersContact: "Contatto",
  adminUsersLoadError: "Impossibile caricare gli utenti.",
  adminUsersRetry: "Riprova",
  adminUsersNoResults: "Nessun utente corrisponde a questi filtri.",
  adminUsersEmpty: "Nessun utente registrato in questo elenco.",

  // Listas e filas
  adminListCopy: "Copia",
  adminListCopied: "Copiato!",
  adminListLoadError: "Impossibile caricare l'elenco.",
  adminListNoResults: "Nessun elemento corrisponde a questa ricerca.",
  adminListEmpty: "Nessun elemento in questo elenco.",
  adminWithdrawDestination: "Destinazione",
  adminWithdrawNoPending: "Nessun prelievo in attesa di elaborazione.",
  adminBankTransferSearch: "Cerca per username o piano",
  adminBankTransferPending: "in sospeso",
  adminBankTransferNone: "Nessun bonifico in attesa di conferma.",
  adminBankTransferConfirmMessage: "Confermare la ricezione di questo bonifico e attivare la registrazione dell'utente?",
  adminBankTransferAuthorized: "Bonifico autorizzato con successo!",

  // Pedidos e pendências
  adminOrdersOrder: "Ordine",
  adminOrdersItems: "articolo/i",
  adminOrdersAwaitingShipment: "In attesa di spedizione",
  adminOrdersSearchPlaceholder: "Cerca per n. ordine, acquirente, venditore o negozio",
  adminPendingSearchPlaceholder: "Cerca per n. ordine o acquirente",
  adminPendingDownloadReceipt: "Scarica ricevuta",
  adminPendingConfirmMessage: "Confermare che il bonifico di questo ordine è stato ricevuto?",
  adminWithdrawRequestedShort: "Richiesto",

  // Catálogo e formulários
  adminFormSave: "Salva",
  adminFormTranslations: "Nome in ogni lingua",
  adminFormRequired: "Campo obbligatorio",
  adminFormImageHint: "Un'immagine, fino a {mb} MB",
  adminFormImageInvalid: "Scegli un file immagine.",
  adminFormImageChoose: "Scegli immagine",
  adminFormImageReplace: "Sostituisci immagine",
  adminFormImageKeepCurrent: "Mantieni l'immagine attuale",
  adminFormImageRemove: "Rimuovi",
  adminFormImageDrop: "oppure trascina qui l'immagine",
  adminCatalogCategories: "Categorie",
  adminCatalogSubcategories: "Sottocategorie",
  adminCatalogEditCategory: "Modifica categoria",
  adminCatalogEditSubcategory: "Modifica sottocategoria",
  adminCatalogEditBrand: "Modifica marca",
  adminCatalogEditType: "Modifica tipo",
  adminCatalogSaved: "Salvato con successo!",
  adminCatalogSearchName: "Cerca per nome in qualsiasi lingua",
  adminCatalogSearchSubcategory: "Cerca per sottocategoria o categoria",
  adminCatalogViewInStore: "Vedi nel negozio",
  adminCatalogChooseCategory: "Scegli la categoria",
  adminCatalogKind: "Tipo di articolo",
  adminCatalogService: "Servizio",
  adminCatalogProduct: "Prodotto",
  adminCatalogChooseSubcategories: "Scegli le sottocategorie",
  adminCatalogAddSubcategories: "Aggiungi sottocategorie",
  adminCatalogLinkedSubcategories: "Sottocategorie già collegate",
  adminCatalogLinkHint: "I collegamenti esistenti non possono essere rimossi qui.",
  adminCatalogLinkFailed: "Salvato, ma alcune sottocategorie non sono state collegate. Modifica l'elemento per riprovare.",
  adminProductsSearch: "Cerca per n., titolo o venditore",

  // Relatórios
  adminReportsThisMonth: "Questo mese",
  adminReportsLastMonth: "Mese scorso",
  adminReportsThisYear: "Quest'anno",
  adminReportsExportPdf: "Esporta PDF",
  adminReportsOrdersCount: "Ordini nel periodo",
  adminReportsPlatformRevenue: "Ricavi della piattaforma",
  adminReportsOnHoldCount: "in attesa",
  adminReportsSearchOrders: "Cerca per n., acquirente, venditore, CF/P.IVA o stato",
  adminReportsOrderShort: "Ordine",
  adminReportsPaymentMethods: "Metodi di pagamento",
  adminReportsInvoices: "Fatture",
  adminReportsBuyerShort: "Acquirente",
  adminReportsSellerShort: "Venditore",
  adminReportsInvoicingOn: "Attiva",
  adminReportsInvoicingOff: "Disattiva",
  adminReportsSubscriptionsCount: "Abbonamenti nel periodo",
  adminReportsTotalPaid: "Totale pagato",
  adminReportsSearchSubscriptions: "Cerca per nome, documento, indirizzo o metodo di pagamento",
  adminReportsWithdrawalsCount: "Prelievi nel periodo",
  adminReportsSearchWithdrawals: "Cerca per nome, e-mail, PayPal o IBAN",

  // Lojas físicas e Bangood
  adminStoresSearch: "Cerca per negozio, titolare, indirizzo o CF/P.IVA",
  adminStoresApproveShort: "Approva",
  adminStoresClose: "Chiudi",
  adminStoresRejectHint: "Il motivo verrà inviato al titolare del negozio.",
  adminBangoodToProcess: "Da elaborare",
  adminBangoodProcessed: "Elaborati",
  adminBangoodNoPending: "Nessun ordine Bangood in attesa di elaborazione.",

  // Endereços, inscrições pagas e integrações
  adminSubscriptionsSearch: "Cerca per nome, username o piano",
  adminIntegrationsConfigured: "Configurato",
  adminIntegrationsNotConfigured: "Non configurato",
  adminIntegrationsLoadFailed: "Impossibile caricare la configurazione attuale. Salvando verrà sostituita.",
  adminIntegrationsMetaDescription: "Invia gli eventi del negozio al Pixel di Meta (Facebook e Instagram Ads).",
  adminIntegrationsGtmDescription: "Aggiunge il contenitore di Google Tag Manager alle pagine del negozio.",
  adminIntegrationsGtmHint: "Codice del contenitore, nel formato GTM-XXXXXXX.",
  adminAddressMenu: "Indirizzi SendCloud",
  adminAddressUserHint: "Scegli il tipo e cerca per nome, username, e-mail o città.",
  adminAddressSearchUser: "Cerca utente",
  adminAddressLoadingUsers: "Caricamento utenti…",
  adminAddressSendcloud: "Indirizzo su SendCloud",
  adminAddressLoadingAddresses: "Caricamento indirizzi…",
  adminAddressNotFound: "L'indirizzo non è nell'elenco?",
  adminAddressRegisterOnSendcloud: "Registralo su SendCloud",
  adminAddressLink: "Collega indirizzo",
  adminAddressLinkTitle: "Collega indirizzo",
  adminAddressConfirmMessage: "Collegare questo indirizzo mittente di SendCloud all'utente?",
  adminAddressLinked: "Indirizzo collegato con successo!",

  // Banners
  adminBannersNew: "Nuova",
  adminBannersDesktop: "Desktop",
  adminBannersMobile: "Mobile",
  adminBannersRatio: "proporzione",
  adminBannersApplyTo: "Applica a",
  adminBannersAllLanguages: "Tutte le lingue",
  adminBannersBothDevices: "desktop e mobile",
  adminBannersImages: "immagini",
  adminBannersVisible: "Visibile nel negozio",
  adminBannersHidden: "Nascosto",
  adminBannersPreview: "Anteprima nel negozio",
  adminBannersRemoveMessage: "Il banner verrà rimosso quando salverai le modifiche.",
  adminBannersSubDelayHint: "Lo stesso tempo vale per tutti e tre i sub banner.",
  adminBannersRatioHint: "Ogni immagine scelta viene ritagliata nella proporzione",
  adminBannersUnsaved: "Modifiche non salvate",
  adminBannersAllSaved: "Tutto salvato",
  adminBannersSaving: "Salvataggio…",

  // Whitelabel
  subnetEditedSuccessfully: "Sottorete modificata con successo!",
  editSubnetData: "Modifica dati della sottorete",
  searchByUsernameNameOrEmail: "Cerca per username, nome o e-mail",
  selectManager: "Seleziona un manager",
  noManagersFound: "Nessun manager trovato",
  adminWhitelabelActive: "Attive",
  adminWhitelabelInactive: "Inattive",
  adminWhitelabelSearch: "Cerca per nome, descrizione, titolare o ID",
  adminWhitelabelTheme: "Tema",
  adminWhitelabelVisualIdentity: "Identità visiva",
  adminWhitelabelFooter: "Footer del negozio",
  adminWhitelabelFaviconHint: "Icona mostrata nella scheda del browser.",
  adminWhitelabelInvalidEmail: "Inserisci un'e-mail valida.",
  adminWhitelabelThemeEmpty: "Compila almeno un campo da personalizzare.",
  adminWhitelabelThemeSaved: "Tema personalizzato con successo!",
  adminWhitelabelThemeSaveError: "Errore durante la personalizzazione del tema.",
  adminWhitelabelThemeLoadError: "Errore nel caricamento del tema attuale.",
};

export default adminPanelDictIT;
